// extracted by mini-css-extract-plugin
export var aiStarIcon = "_su-2";
export var container = "_su-4";
export var dismissButton = "_su-3";
export var hasPaddingBottom = "_su-6";
export var last = "_su-e";
export var scrollbarThumb = "_su-c";
export var scrollbarTrack = "_su-b";
export var selected = "_su-9";
export var spin = "_su-1";
export var spinning = "_su-0";
export var suggestionItem = "_su-d";
export var suggestionsPanel = "_su-5";
export var tonePill = "_su-8";
export var tonesContainer = "_su-7";
export var unselected = "_su-a";